export const getPurchasedCoursesParams = {
	limit: 100,
	page: 1,
};
